module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/seperation-mobile-phone-1.9f9b777f.png";